import BackendApiClient from './BackendApiClient';
import { OrderFulfillmentStatus } from '../exports/Constants';

class OrderFulfillmentsManager {
  update = (id, data) =>
    BackendApiClient.requestAuthorized({
      method: 'PUT',
      url: `/staff/fulfillments/${id}`,
      data,
    });

  markReviewed = (id) =>
    this.update(id, {
      status: OrderFulfillmentStatus.Reviewed,
    });
}

export default new OrderFulfillmentsManager();
